export const createSurchargeSlice = (set, get) => ({
  surcharge: {
    data: null,
    showSurchargeConfirmationModal: false,
  },
  surchargeActions: {
    setSurchargeData: (surchargeData) =>
      set((state) => {
        state.surcharge.data = surchargeData;
      }),
    setShowSurchargeConfirmationModal: (showSurchargeConfirmationModal) =>
      set((state) => {
        state.surcharge.showSurchargeConfirmationModal =
          showSurchargeConfirmationModal;
      }),
  },
});
